import { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("am_token");
    if (!t) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("am_token"))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    // A misconfigured REACT_APP_BACKEND_URL makes this hit the static frontend server,
    // which answers 200 with index.html — don't treat that as a successful login.
    if (!data?.token || !data?.user) {
      throw new Error("Could not reach the store server. Check REACT_APP_BACKEND_URL and redeploy the frontend.");
    }
    localStorage.setItem("am_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("am_token");
    setUser(null);
    window.location.href = "/login";
  };

  const isOwner = user?.role === "owner";

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout, isOwner }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export { apiError };
